import React, { useContext, useEffect, useState } from "react";
import PropTypes from "prop-types";

import Chat from "../common/Chat";
import Sessions from "../common/Chat/Sessions";
import ChatSessionContext from "../../contexts/ChatSessionContext";
import { useLocation } from "react-router-dom";

const Mini = ({ userId, onClose, onMaximize }) => {
  const { currentSession, setCurrentSession } = useContext(ChatSessionContext);
  const location = useLocation();
  const [init, setInit] = useState(false);

  useEffect(() => {
    if (init) {
      onClose();
      return;
    }

    setInit(true);
  }, [location]);

  /**
   * Handle when selecting a session
   * @param {string} sessionId
   */
  const handleSelectSession = (sessionId, userId) => {
    setCurrentSession(sessionId, userId);
  };

  /**
   * Handle return from session
   */
  const handleReturn = () => {
    setCurrentSession(undefined);
  };

  /**
   * Handle closing window
   */
  const handleClose = () => {
    setCurrentSession(undefined);
    onClose();
  };

  /**
   * Handle maximizing and navigating to chat page
   */
  const handleMaximize = () => onMaximize();

  return (
    <div className="mini-chats">
      <div className="mini-chats-window">
        {currentSession && currentSession.endUser ? (
          <Chat
            sessionId={currentSession}
            userId={userId}
            mini={true}
            onMaximize={handleMaximize}
            onClose={handleClose}
            onReturn={handleReturn}
          />
        ) : (
          <Sessions
            userId={userId}
            onSelectSession={handleSelectSession}
            onClose={handleClose}
            onMaximize={handleMaximize}
            mini={true}
          />
        )}
      </div>
    </div>
  );
};

Mini.propTypes = {
  key: PropTypes.string,
  userId: PropTypes.string,
  sessions: PropTypes.array,
  onClose: PropTypes.func,
  onMaximize: PropTypes.func,
};

Mini.defaultProps = {
  key: "1",
  sessionId: "",
  userId: "",
  sessions: [],
  onClose: () => {},
  onMaximize: () => {},
};

export default Mini;
